// extracted by mini-css-extract-plugin
export default {"wrapper":"Tabs_wrapper__Zo+kI","tabContent":"Tabs_tabContent__qSRH3","tabExtraContent":"Tabs_tabExtraContent__ZvZS0"};